<rt-confirm-dialog
  [title]="'app.candidate.cv_delete_dialog.title' | translate"
  [variant]="ConfirmDialogVariant.Information"
  [triggerUpdateOnInit]="true"
  [safeFooter]="false"
  [agreeLabel]="'app.common.confirm' | translate"
  [cancelLabel]="'app.common.cancel' | translate"
  [closePayload]="$any(state)"
  [isCancelable]="true"
>
  <p>{{ 'app.candidate.cv_delete_dialog.about_to_delete' | translate }}</p>

  <rt-group margin-top-small variant="vertical stacked">
    <rt-radio [hasLensIcon]="true" [checked]="state.deleteParsedData" (click)="setDelete(true)">
      {{ 'app.candidate.cv_delete_dialog.do_delete' | translate }}
    </rt-radio>
    <rt-radio [hasLensIcon]="true" [checked]="!state.deleteParsedData" (click)="setDelete(false)">
      {{ 'app.candidate.cv_delete_dialog.no_delete' | translate }}
    </rt-radio>
  </rt-group>
</rt-confirm-dialog>
